/* tslint:disable */
/* eslint-disable */
/**
 * SI Implicit-Bias API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImplicitBiasResultDirection {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

export function ImplicitBiasResultDirectionFromJSON(json: any): ImplicitBiasResultDirection {
    return ImplicitBiasResultDirectionFromJSONTyped(json, false);
}

export function ImplicitBiasResultDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImplicitBiasResultDirection {
    return json as ImplicitBiasResultDirection;
}

export function ImplicitBiasResultDirectionToJSON(value?: ImplicitBiasResultDirection | null): any {
    return value as any;
}

